"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggingProvider = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var _1 = require(".");

var LoggingProvider = function LoggingProvider(_a) {
  var sentryDsn = _a.sentryDsn,
      sentryEnv = _a.sentryEnv,
      consumerId = _a.consumerId,
      sentryRelease = _a.sentryRelease,
      _b = _a.customOptions,
      customOptions = _b === void 0 ? {} : _b,
      children = _a.children;
  var Provider = _1.LoggingContext.Provider;
  return react_1.default.createElement(Provider, {
    value: (0, _1.getLogger)({
      sentryDsn: sentryDsn,
      sentryEnv: sentryEnv,
      sentryRelease: sentryRelease,
      customOptions: customOptions,
      consumerId: consumerId
    })
  }, children);
};

exports.LoggingProvider = LoggingProvider;
exports.LoggingProvider.displayName = 'LoggingProvider';